<template>
  <v-list-item @click="toggleAnswerFilter()" :color="inputValue ? 'accent darken-1' : 'grey darken-2'">
    <v-list-item-action style="min-width: 42px;">
      <v-checkbox readonly :input-value="inputValue"></v-checkbox>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title>{{ answer.label }}</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  components: {},
  name: 'answer-list',
  props: ['answer', 'questionId'],
  computed: {
    ...mapGetters(['CustomerPageFilters']),
    inputValue() {
      return (
        !_.isUndefined(this.CustomerPageFilters.answers[this.questionId]) &&
        this.CustomerPageFilters.answers[this.questionId].includes(this.answer.id)
      );
    }
  },
  methods: {
    ...mapActions(['addAnswerFilter', 'removeAnswerFilter', 'getCustomerPage']),
    getPage: _.debounce(function() {
      this.getCustomerPage(false)
        .then(() => {})
        .catch(error => {
          console.log(error);
        });
    }, 250),
    toggleAnswerFilter() {
      if (
        !_.isUndefined(this.CustomerPageFilters.answers[this.questionId]) &&
        this.CustomerPageFilters.answers[this.questionId].includes(this.answer.id)
      ) {
        this.removeAnswerFilter({ questionId: this.questionId, answerId: this.answer.id });
      } else {
        this.addAnswerFilter({ questionId: this.questionId, answerId: this.answer.id });
      }
      this.getPage();
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .v-list-item {
  height: auto !important;
  user-select: unset;
}

::v-deep .filter-header {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
}

::v-deep .v-list-item--avatar {
  height: 36px;
}

::v-deep .v-list-item__action {
  margin: 0;
}

::v-deep .input-group {
  /*padding-top: 0;*/

  label {
    font-size: 13px;
  }

  .input-group__details::before {
    height: 0;
  }
}
</style>
